// extracted by mini-css-extract-plugin
module.exports = {"loginTeams":"TeamsLogin_loginTeams__2k9H1","error":"TeamsLogin_error__3jr02"};